import {
  CAPACITY_PIPELINE_NETWORK_SUMMARY_ITEM,
  GRAPH_THROUGHPUT_PIPELINE_NETWORK_SUMMARY_ITEM,
  HYDROCARBON_PIPELINE_NETWORK_SUMMARY_ITEM,
  NAME_PIPELINE_NETWORK_SUMMARY_ITEM,
  STATUS_PIPELINE_NETWORK_SUMMARY_ITEM,
  START_UP_PIPELINE_NETWORK_SUMMARY_ITEM,
  LENGTH_KM_PIPELINE_NETWORK_SUMMARY_ITEM,
} from '../../../../components/SummaryList/SummaryItems/pipelineNetwork';
import {
  DIAMETER_SUMMARY_ITEM,
  OPERATOR_SUMMARY_ITEM,
} from '../../../../components/SummaryList/SummaryItems/base';

export default () => {
  return [
    NAME_PIPELINE_NETWORK_SUMMARY_ITEM,
    OPERATOR_SUMMARY_ITEM,
    STATUS_PIPELINE_NETWORK_SUMMARY_ITEM,
    DIAMETER_SUMMARY_ITEM,
    CAPACITY_PIPELINE_NETWORK_SUMMARY_ITEM,
    HYDROCARBON_PIPELINE_NETWORK_SUMMARY_ITEM,
    START_UP_PIPELINE_NETWORK_SUMMARY_ITEM,
    LENGTH_KM_PIPELINE_NETWORK_SUMMARY_ITEM,
    GRAPH_THROUGHPUT_PIPELINE_NETWORK_SUMMARY_ITEM,
  ];
};
